"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getOffers } from "../api";
import type { OffersResponse } from "../types";
export function useOffers(contractAddress, tokenId, options) {
  const $ = _c(10);
  const limit = options?.limit;
  const page = options?.page;
  let t0;
  let t1;
  if ($[0] !== contractAddress || $[1] !== limit || $[2] !== page || $[3] !== tokenId) {
    t0 = ["nft-offers", contractAddress, tokenId, limit, page];
    t1 = () => getOffers(contractAddress, String(tokenId), {
      limit,
      page
    });
    $[0] = contractAddress;
    $[1] = limit;
    $[2] = page;
    $[3] = tokenId;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  const t2 = options?.enabled !== false && Boolean(contractAddress && tokenId);
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      placeholderData: _temp,
      staleTime: 15000
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useQuery(t3);
}
function _temp(previous) {
  return previous;
}